import React from 'react';
import * as PropTypes from 'prop-types';
import { SegmentLoader } from '@design-system-etat/dsfr-react';
import Autosuggest from 'react-autosuggest';
import styles from './ChampsAutocomplete.module.scss';

const ChampsAutocomplete = ({
    label,
    suggestions,
    getSuggestionValue,
    inputProps,
    onSuggestionsFetchRequested,
    onSuggestionSelected,
    onSuggestionsClearRequested,
    renderSuggestion,
    isLoading,
    shouldRenderOnFocus,
    error,
    afficherRequired,
}) => {
    let texteValidation;
    let inputGroupClassName = 'fr-input-group dsmi-input-group';
    let inputClassName = 'fr-input ';

    if (error) {
        inputGroupClassName += ' fr-input-group--error';
        inputClassName += ' fr-input--error ';
        if (typeof error === 'object' && 'message' in error && error.message) {
            texteValidation = {
                id: `desc-error`,
                message: error.message,
                className: 'fr-error-text',
            };
        }
    }

    inputClassName += ` ${styles.inputAutocomplete}`;

    if (afficherRequired !== false) {
        inputGroupClassName += ' required';
    }

    const renderInputComponent = (inputAttributs) => {
        return (
            <>
                <label className="fr-label" htmlFor={inputAttributs.name}>
                    <span className="fr-label-texte">{label}</span>
                </label>
                <SegmentLoader isLoading={!!isLoading} taille="sm">
                    <div className="fr-input-wrap fr-fi-search-line">
                        <input
                            id={inputAttributs.name}
                            {...inputAttributs}
                            aria-required={!!afficherRequired}
                        />
                    </div>
                </SegmentLoader>
                {texteValidation && (
                    <p id={texteValidation.id} className={texteValidation.className}>
                        {texteValidation.message}
                    </p>
                )}
            </>
        );
    };

    return (
        <Autosuggest
            theme={{
                container: inputGroupClassName,
                containerOpen: '',
                input: inputClassName,
                inputOpen: 'react-autosuggest__input--open',
                inputFocused: 'react-autosuggest__input--focused',
                suggestionsContainer: styles.inputAutocomplete__suggestion,
                suggestionsContainerOpen: '',
                suggestionsList: styles.inputAutocomplete__suggestionList,
                suggestion: styles.inputAutocomplete__suggestionElement,
                suggestionFirst: '',
                suggestionHighlighted: styles.inputAutocomplete__suggestionElement_focus,
                sectionContainer: 'react-autosuggest__section-container',
                sectionContainerFirst: 'react-autosuggest__section-container--first',
                sectionTitle: 'react-autosuggest__section-title',
            }}
            renderInputComponent={renderInputComponent}
            suggestions={suggestions ?? []}
            getSuggestionValue={getSuggestionValue}
            inputProps={inputProps}
            onSuggestionsFetchRequested={onSuggestionsFetchRequested}
            onSuggestionsClearRequested={onSuggestionsClearRequested}
            onSuggestionSelected={onSuggestionSelected}
            shouldRenderSuggestions={shouldRenderOnFocus ? () => !!suggestions : undefined}
            renderSuggestion={renderSuggestion}
        />
    );
};

ChampsAutocomplete.propTypes = {
    label: PropTypes.string.isRequired,
    suggestions: PropTypes.arrayOf(PropTypes.any).isRequired,
    getSuggestionValue: PropTypes.func.isRequired,
    inputProps: PropTypes.object.isRequired,
    onSuggestionsFetchRequested: PropTypes.func.isRequired,
    onSuggestionSelected: PropTypes.func.isRequired,
    onSuggestionsClearRequested: PropTypes.func,
    renderSuggestion: PropTypes.func.isRequired,
    isLoading: PropTypes.bool,
    shouldRenderOnFocus: PropTypes.bool,
    error: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.shape({
            message: PropTypes.string,
        }),
    ]),
    afficherRequired: PropTypes.bool,
};

export default ChampsAutocomplete;
